import { supabase } from './api'

export async function getAllData(setLoading) {
    setLoading(true)
  const { data, error } = await supabase
    .from("collegelistinfo")
    .select()
    // .order("id", { ascending: true });
  if (error) {
    throw new Error("Failed to fetch data",error);
  }
  setLoading(false)

  return data;
}

export async function getIdData(id) {
  const { data, error } = await supabase.from('collegelistinfo').select()
  .eq('id', id);
  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}

export async function addData(adata) {
  const { data, error } = await supabase.from('collegelistinfo').insert(adata).select();

  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}


export async function updateData(udata) {
  //console.log("udata",udata);
  const { data, error } = await supabase.from('collegelistinfo').update(udata).eq('id', udata.id).select();
  console.log("error",error,data);
  if (error) {

    throw new Error('Failed to fetch data')

  }

  return data;
}

export async function deleteIdData(id) {
  const { data, error } = await supabase.from('collegelistinfo').delete()
  .eq('id', id);
  if (error) {
    throw new Error('Failed to fetch data')
  }

  return data;
}
